import { axiosInstance as axios, handleAxiosErrors } from '../../_utils';
import config from '../../store/_config';
import { convertUserDetailedInformationToAReadableFormat } from '../../selectors/converterSelector';
import { toggleLoading, setUserInfo } from '../userActions';

export const axiosRequestPostmenJSONFields = () => {
    const { url } = config.user.postmen.format;

    return axios.get(url, {
        withCredentials: true,
    });

    //Hard core for CORS issue only
    // const result = {
    //   "data": {
    //     "shippers": {
    //         "australia-post": {
    //             "name": "Australia Post",
    //             "parameters": {
    //                 "Credential_1": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "account_number"
    //                 },
    //                 "Credential_2": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "password"
    //                 },
    //                 "Credential_3": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "api_key"
    //                 }
    //             }
    //         },
    //         "apc-overnight": {
    //             "name": "APC Overnight",
    //             "parameters": {
    //                 "Credential_1": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "password"
    //                 },
    //                 "Credential_2": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "user_email"
    //                 }
    //             }
    //         },
    //         "ups-mi": {
    //             "name": "UPS Mail Innovation",
    //             "parameters": {
    //                 "Credential_1": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "account_number"
    //                 },
    //                 "Credential_2": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "access_key"
    //                 },
    //                 "Credential_3": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "password"
    //                 },
    //                 "Credential_4": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "user_identifier"
    //                 },
    //                 "Credential_5": {
    //                     "Label": "",
    //                     "Type": "text",
    //                     "Key": "cost_center"
    //                 },
    //                 "Credential_6": {
    //                     "Label": "",
    //                     "Type": "select",
    //                     "Key": "usps_endorsement",
    //                     "Options": [
    //                         "return_service_requested",
    //                         "forwarding_service_requested",
    //                         "address_service_requested",
    //                         "change_service_requested",
    //                         "no_service_selected"
    //                     ]
    //                 }
    //             }
    //         }
    //     },
    //   },
    //   "status": true,
    //   "message": ""
    // }

    // return new Promise((res, rej) => {
    //   setTimeout(() => {
    //     res(result)
    //   }, 100)
    // })
};

export const axiousRequestPostmenListing = () => {
    let { url, query } = config.user.postmen.listing;

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

const requestPostmen = () => {
    return (dispatch) => {
        dispatch(toggleLoading('postmenList', true));
        return axiousRequestPostmenListing()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    {
                        Postmen:
                            response.data.data
                                .readMemberPostmenShippingAccounts,
                    }
                );
                dispatch(setUserInfo(userInfo));

                dispatch(toggleLoading('postmenList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('postmenList', false));
            });
    };
};

const axiosCreatePostman = (formData) => {
    const { url, query } = config.user.createPostman;

    const data = {
        id: query,
        variables: {
            Input: formData,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Create a new postmen
 *
 * @param formData
 * @param callback
 */
export const createPostman = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosCreatePostman(formData)
            .then((response) => {
                dispatch(requestPostmen());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

export const axiosDeletePostman = (ID, memberID = null) => {
    let { url, query } = config.user.deletePostman;

    let data = {
        id: query,
        variables: {
            ID: Number(ID),
        },
    };

    if (memberID != null) {
        data.variables.MemberID = memberID;
    }

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Delete the selected postmen
 *
 * @param id
 * @param callback
 */
export const deletePostman = (id, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosDeletePostman(id)
            .then((response) => {
                dispatch(requestPostmen());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

const axiosEditPostman = (formData) => {
    const { url, query } = config.user.editPostman;

    let editPostmanID = 0;
    if (formData.ID !== null) {
        editPostmanID = formData.ID;
        delete formData.ID;
    }

    let data = {
        id: query,
        variables: {
            ID: editPostmanID,
            Input: formData,
        },
    };

    return axios.post(url, data, {
        withCredentials: true,
    });
};

/**
 * Edit the selected postmen
 *
 * @param id
 * @param callback
 */
export const editPostman = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosEditPostman(formData)
            .then((response) => {
                dispatch(requestPostmen());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
